// Mismo cálculo que la API al guardar (utils/posiciones.ts): deja `campo` en 1..n; si `id` está en la lista,
// se inserta en `posicion` y los demás se recorren. Mientras la posición no sea válida, la lista no cambia.
export const recorrerPosiciones = (lista, campo, id, posicion) => {
    if (!Number.isInteger(posicion) || posicion < 1) return lista;
    const movido = lista.find(dato => dato._id === id);
    const resto = lista.filter(dato => dato !== movido).sort((a, b) => (Number(a[campo]) || 0) - (Number(b[campo]) || 0));
    if (movido) resto.splice(Math.min(posicion - 1, resto.length), 0, movido);
    return resto.map((dato, i) => ({ ...dato, [campo]: i + 1 }));
};
